import { render } from "./NavbarElement.vue?vue&type=template&id=5cfd314d&scoped=true"
import script from "./NavbarElement.vue?vue&type=script&lang=js"
export * from "./NavbarElement.vue?vue&type=script&lang=js"

import "./NavbarElement.vue?vue&type=style&index=0&id=5cfd314d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cfd314d"]])

export default __exports__